module.exports = "<div class=\"ctx-tooltip-content\">\n    <div class=\"ctx-tooltip-container\"\n         ng-class=\"{'ctx-tooltip-up': !$ctrl.down, 'ctx-tooltip-down': $ctrl.down, 'ctx-tooltip-show': $ctrl.show, 'ctx-tooltip-hide': $ctrl.hide}\"\n         ng-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxTooltip/ctxTooltip.template.html
// module id = 280
// module chunks = 0 1